import { createStore } from "vuex";
import Token from "./utilities/jwt/Token.js";

export default createStore({
  state() {
    return {
      userLogged: null,
      views: {
        solicitation: {
          consult: {
            dialogDetails: false,
          },
          finalize: {
            dialogAttending: false,
          },
        },
        operator: {
          dialogForm: false,
          dialogUpload: false,
        },
        external: {
          selectType: false,
          dialogExternalCard: false,
        },
      },
    };
  },
  getters: {
    getUserLogged(state) {
      return state.userLogged;
    },
    getSelectType(state) {
      return state.views.external.selectType;
    },
    getDialogExternalCard(state) {
      return state.views.external.dialogExternalCard;
    },
  },
  mutations: {
    setUserLogged(state, token) {
      token = [
        {
          id: token.code,
          nome: token.name,
          services: token.services,
          email: token.user_name,
          authorities: token.authorities,
          personId: token.personId,
        },
      ];
      state.userLogged = token[0];
    },
    setSelectType(state, payload) {
      state.views.external.selectType = payload;
    },
    setDialogExternalCard(state, payload) {
      state.views.external.dialogExternalCard = payload;
    },
  },
  actions: {
    setUserLogged({ commit }) {
      commit("setUserLogged", new Token().decodeToken('access_token'));
    },
  },
});
